/** 样式 */

<style scoped lang="scss" src="./BimEngineeringChange.vue.scss"></style>
<template>
  <div>
    <div
      v-show="bimEngineeringChange_show && !isFold"
      class="table bimVideo no-select bimEngineeringChange"
      :class="{
        packUp: packUp,
      }"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      style="width: 328px; margin: 105px 0 0 -395px"
    >
      <h3 class="canmove">
        变更项管理树
        <i class="el-icon-close" @click="bimEngineeringChange_click"></i>
        <i class="el-icon-arrow-down" @click="packUp = !packUp"></i>
      </h3>
      <div class="tab-first">
        <!-- <el-scrollbar style="height: 419.3px; width: 400px"> -->
        <BimEngineeringChangeTree :theEditor="theEditor" :infoList="infoData" />

        <!-- 地点弹窗 -->
        <!-- </el-scrollbar> -->
      </div>
      <el-divider></el-divider>
      <el-button
        type="primary"
        @click="createBimEngineeringChangeItem()"
        style="margin: 10px"
        ><i class="el-icon-zengjia"></i> 新增变更项
      </el-button>
      <BimEngineeringChangeItem
        v-show="changeItemShow"
        :hutDown="shutDown"
        :title="title"
        ref="bimEngineeringChangeItem"
        style="margin: 105px 0px 0px -750px"
      >
      </BimEngineeringChangeItem>
      <BimEngineeringChangeItemDetail
        v-show="showInfoType"
        :hutDown="shutDown2"
        :detailData="detailData"
        ref="bimEngineeringChangeItemDetail"
      ></BimEngineeringChangeItemDetail>
      <!-- 你在这引入了子页面  ref 这个是关键 ref="bimEngineeringChangeItemDetail" 这是指定这个是子页面的关键 -->
    </div>
  </div>
</template>
<script>
/* 异步加载 一些弹窗组件 */
const BimEngineeringChangeTree = () =>
  import("./bimEngineeringChangeTree/BimEngineeringChangeTree");
const BimEngineeringChangeCategory = () =>
  import("./bimEngineeringChangeCategory/BimEngineeringChangeCategory.vue");
const BimEngineeringChangeItem = () =>
  import("./bimEngineeringChangeItem/BimEngineeringChangeItem.vue");
const BimEngineeringChangeItemDetail = () =>
  import("./bimEngineeringChangeItemDetail/BimEngineeringChangeItemDetail.vue");

//按需加载
import { getBimEngineeringChange } from "../../../api/api";
import { EventBus } from "../../../static/js/event-bus.js";
export default {
  name: "",
  components: {
    BimEngineeringChangeTree,
    BimEngineeringChangeCategory,
    BimEngineeringChangeItem,
    BimEngineeringChangeItemDetail,
  },
  props: [],
  data() {
    return {
      packUp: false,
      showInfoType: false,
      changeItemShow: false,
      loading: false,
      bimEngineeringChange_show: true,
      isFold: false,
      state: false,
      form: {},
      detailData: {},
      title: "新增",
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    //一个对象，键是需要观察的表达式，值是对应回调函数。
    //值也可以是方法名，或者包含选项的对象。
    //Vue 实例将会在实例化时调用 watch()，遍历 watch 对象的每一个 property。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
  },

  methods: {
    // 树形数据请求
    // 初始化列表
    infoData(data) {
      console.log(data);
      this.$NProgress.set(0.8).inc(0.2);
      this.loading = true;
      this.showInfoType = true; //这是控制子页面展示的
      this.changeItemShow = false;
      this.detailData = data;
      //这是在父页面调用子页面的方法固定写法
      //init 是子页面中的方法   必须存在
      this.$nextTick(() => {
        this.$refs.bimEngineeringChangeItemDetail.init();
      });

      console.log(data);
      let formEditor = this.$refs.bimEngineeringChangeItemDetail;
      formEditor.id = data.id;
      this.$NProgress.done(true);
      this.loading = false;
    },
    initTreeData() {
      this.$NProgress.set(0.8).inc(0.2);
      this.loading = true;
      let tempdata = [];
      let modelData = {
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getBimEngineeringChange(modelData).then((res) => {
        tempdata = res.data.data;
        console.log(res.data.data);
        tempdata.forEach((item) => {
          console.log(item);
          if (item["children"] != null && item["children"].length > 0) {
            item["transformType"] = "directory";
          }
          item.children.forEach((i) => {
            console.log(i);
          });
          this.treedata = tempdata;
        });
      });
      this.$NProgress.done(true);
      this.loading = false;
    },
    bimEngineeringChange_click() {
      //alert("触发");
      this.$emit("bimEngineeringChangeBox_close");
    },

    //弹出新增标记弹窗
    createBimEngineeringChangeItem() {
      this.title = "新增";
      this.changeItemShow = true;
      this.showInfoType = false;
      let formEditor = this.$refs.bimEngineeringChangeItem.form;
      formEditor.id = 0;
      formEditor.pId = 0;
      formEditor.name = "";
      formEditor.projectId = window.sessionStorage.getItem("nowProjectId");
      formEditor.NewModel = "";
      formEditor.OldModel = "";
      formEditor.desc = "";
      formEditor.sort = "";
    },
    // 新增弹框关闭
    shutDown() {
      this.changeItemShow = false;
    },
    shutDown2() {
      this.showInfoType = false;
    },
    //// 编辑变更项
    theEditor(index, row) {
      this.title = "编辑";
      this.changeItemShow = true;
      this.showInfoType = false;
      let formEditor = this.$refs.bimEngineeringChangeItem.form;
      console.log("index", index);
      formEditor.id = index.bimEngineeringChangeItem.id;
      formEditor.pId = index.bimEngineeringChangeItem.pId;
      formEditor.name = index.bimEngineeringChangeItem.name;
      formEditor.projectId = index.bimEngineeringChangeItem.projectId;
      formEditor.NewModel = index.bimEngineeringChangeItem.newModel || "";
      formEditor.OldModel = index.bimEngineeringChangeItem.oldModel || "";
      formEditor.desc = index.bimEngineeringChangeItem.description;
      formEditor.sort = index.bimEngineeringChangeItem.sort;
    },
  },
  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  max-height: 540px;
  max-width: 1500px;
  min-height: 200px;
  padding: 0;
  overflow: hidden;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;

  h3 {
    font-size: 12px;
    text-indent: 14px;

    i.el-icon-close {
      width: 30px;
      margin: 6px 6px 0 0;
    }
  }

  .el-scrollbar {
    // display: flex;
    max-height: 450px;

    .el-scrollbar__wrap {
      overflow-x: hidden;
      overflow-y: auto;
      min-width: 236px;
      width: 440px !important;
    }
  }

  .el-divider {
    margin: 0;
    position: a;
    @include background_color("t_color3_op2");
  }

  .el-button--primary {
    @include lheight(26);
    @include font_color("t_color_op1");
    @include background_color("t_color1_op2");
    @include border_color("t_color1_op2");
    padding: 0 6px;
    margin: 12px 0 0 8px;

    span {
      @include lheight(26);
      font-size: 12px;
      display: block;
      text-align: center;
    }

    &:hover {
      @include background_color("t_color1_op1");
      @include border_color("t_color1_op1");
    }
  }
}

// 收起动画
.packUp {
  max-height: 27px;
  min-height: 27px;
  // width: 136px;
  overflow: hidden;
}

.modaClose {
  max-height: 0;
  min-height: 0;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
  height: 100%;
  overflow-y: auto;
}

.el-scrollbar__bar {
  &.is-horizontal {
    right: 0px;
    bottom: 0px;
  }

  &.is-vertical {
    right: 1px;
    bottom: 1px;
  }
}

.el-scrollbar {
  height: 419.3px;
}

.foot {
  padding-bottom: 12px;
  padding-right: 12px;
}

.el-button {
  @include lheight(26);
  padding: 0 6px;
  margin: 12px 0 0 8px;
}

.el-button--default {
  @include font_color("t_color_op2");
  @include background_color("t_color3_op2");
  @include border_color("t_color_op2");

  span {
    @include lheight(24);
    font-size: 12px;
    display: block;
    text-align: center;
  }

  &:hover {
    @include background_color("t_color3_op1");
    @include border_color("t_color_op1");
    @include font_color("t_color_op1");
  }
}
</style>
